import Loader from "../../loader";
import { pipGetProfile } from "../../../utils/pip";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchProfile, updateProfile } from "../../../redux/actions/authAction";

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {pathname} = useLocation()
  const { isLoading } = useSelector((state) => state.authReducer);
  const profileData = useMemo(() => pipGetProfile(), [pathname]);
  const [previewImage, setPreviewImage] = useState(
    profileData?.avatar_url || "/assets/img/user_profile.png",
  );
  const [formData, setFormData] = useState({
    full_name: profileData?.full_name || "",
    email: profileData?.email || "",
    phone_no: profileData?.phone_no || "",
    notes: profileData?.notes || profileData?.notes || "",
    image: null,
  });

  useEffect(() => {
    return () => {
      if (previewImage?.startsWith("blob:")) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    if (previewImage?.startsWith("blob:")) {
      URL.revokeObjectURL(previewImage);
    }

    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
    setPreviewImage(URL.createObjectURL(file));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const payload = new FormData();
    payload.append("full_name", formData.full_name);
    payload.append("notes", formData.notes);

    if (formData.image) {
      payload.append("image", formData.image);
    }

    dispatch(
      updateProfile({
        payload,
        callback: (response) => {
          if (!response?.success) return;
          dispatch(fetchProfile());

          setTimeout(()=>{
navigate("/account-setting/my-account");
          },1000)
          // const updatedUser = {
          //   ...profileData,
          //   ...(response?.user || response?.data || response?.updatedUser || {}),
          //   full_name: response?.user?.full_name ||
          //     response?.data?.full_name ||
          //     response?.updatedUser?.full_name ||
          //     formData.full_name,
          //   notes: response?.user?.notes ||
          //     response?.user?.notes ||
          //     response?.data?.notes ||
          //     response?.data?.notes ||
          //     response?.updatedUser?.notes ||
          //     response?.updatedUser?.notes ||
          //     formData.notes,
          //   avatar_url: response?.user?.avatar_url ||
          //     response?.data?.avatar_url ||
          //     response?.updatedUser?.avatar_url ||
          //     previewImage,
          // };

          // pipSaveProfile(updatedUser);
          
        },
      }),
    );
  };

  if(isLoading){
    return <Loader/>
  }
  
  return (
    <>
      <div>
        <h3 class="ct_fs_32 ct_switzer_bold mb-5">Edit Profile</h3>

        {/* Profile header */}
        <div class="profile-header justify-content-between flex-wrap">
          <div className="d-flex align-items-center gap-3">
            <label className="position-relative">
              <input
                type="file"
                className="d-none"
                accept="image/*"
                onChange={handleImageChange}
              />
              <img src={previewImage} alt="User" class="ct_profile_avatar_75" />
              <div className="ct_edit_icon">
                <i class="fa-solid fa-pen"></i>
              </div>
            </label>
            {/* <div>
              <div class="ct_text_clr_4B5563 mb-2">
                <h4>{profileData?.full_name || "#N/A"}</h4>
              </div>
            </div> */}
          </div>
        </div>

        {/* Personal Info */}
        <div class="account-card">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mb-4">
                  <label className="mb-2 d-block">Full Name</label>
                  <input
                    type="text"
                    className="form-control ct_input"
                    placeholder="Enter Full Name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group mb-4">
                  <label className="mb-2 d-block">Email</label>
                  <input
                    type="email"
                    className="form-control ct_input"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    readOnly
                  />
                </div>
              </div>
             {formData.phone_no && <div className="col-md-12">
                <div className="form-group mb-4">
                  <label className="mb-2 d-block">Phone</label>
                  <input
                    type="text"
                    className="form-control ct_input"
                    placeholder="Enter Phone"
                    name="phone_no"
                    value={formData.phone_no}
                    readOnly
                  />
                </div>
              </div>}
              <div className="col-md-12">
                <div className="form-group mb-4">
                  <label className="mb-2 d-block">Note</label>
                  <textarea
                    className="form-control ct_input"
                    placeholder="Enter Note"
                    name="notes"
                    rows="4"
                    value={formData.notes}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="mt-4">
              <button
                type="submit"
                className="ct_green_bnt mx-auto"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
